import * as URI from 'urijs';
import { MediaType, MediaDocument } from '../../media-document.model';
import { ICONOCLAST_URL } from '../content-document-adapter.config';

export class ContentDocumentYoutubeAdapter {
    static toContentDocument(document: any): MediaDocument {
        let contentDocument = new MediaDocument(document);
        let author = document.authors && document.authors[0] ? document.authors[0] : {};

        contentDocument.documentId = document.documentId;
        contentDocument.isHosted = document.isHosted;
        contentDocument.date = document.date;
        contentDocument.dupDocs = [];
        contentDocument.dupDocsCount = document.dupDocsCount;
        contentDocument.dupDocsIdsRemaining = document.remainingDupDocsIds;
        contentDocument.keywords = document.keywords;
        contentDocument.matchSentences = [document.matchSentence || document.tagContextMatchSentence];
        contentDocument.mediaType = MediaType.Youtube;
        contentDocument.mediaTypeIcon = document.mediaTypeIcon || contentDocument.mediaType;
        contentDocument.provider = document.provider;
        contentDocument.sentiment = document.isSentimentModified ? document.originalSentiment : document.sentiment;
        contentDocument.sentimentOverride = document.isSentimentModified ? document.sentiment : '';
        contentDocument.sourceAvatarRounded = true;
        contentDocument.sourceAvatarImgUrl = document.url ? `${ICONOCLAST_URL}/tubicon?videoId=${new URI(document.url).search(true).v}` : '';
        contentDocument.sourceAvatarLinkUrl = author.url;
        contentDocument.sourceCountryCode = document.country || document.countryCode;
        contentDocument.sourceName = author.name || author.handle || 'Unknown';
        contentDocument.sourceNameUrl = author.url;
        contentDocument.tags = document.tags;
        contentDocument.title = document.title;
        contentDocument.titleUrl = document.redirectUrl || document.url;
        contentDocument.videoUrl = document.url;
        contentDocument.language = document.language;

        // TODO: not sure if we need this, might be same as sourceUrl
        contentDocument.url = document.redirectUrl || document.url;

        // TODO: not sure if we should bake in support for these but putting them in for now
        contentDocument.reachCount = document.reach;
        contentDocument.potentialReach = document.potentialReach;

        return contentDocument;
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/content-documents/media-document/adapter/adapters/content-document-youtube.adapter.ts